var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7399 25.8177C51.7399 40.0764 40.1577 51.6354 25.8703 51.6354C11.5822 51.6354 0 40.0764 0 25.8177C0 11.559 11.5822 0 25.8703 0C40.1577 0 51.7399 11.559 51.7399 25.8177Z",
    fill: "#B8B8BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5883 20.5353C34.5883 25.818 30.6657 30.1011 25.8268 30.1011C20.9878 30.1011 17.0652 25.818 17.0652 20.5353C17.0652 15.2526 20.9878 10.9702 25.8268 10.9702C30.6657 10.9702 34.5883 15.2526 34.5883 20.5353ZM9.74219 41.2409C13.809 37.0067 19.5288 34.3658 25.8705 34.3658C32.2122 34.3658 37.932 37.0067 41.9988 41.2409C37.932 45.4758 32.2122 48.1168 25.8705 48.1168C19.5288 48.1168 13.809 45.4758 9.74219 41.2409Z",
    fill: "#FEFEFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1f460586bf586485a2149dd3c6175667.svg";
export { ForwardRef as ReactComponent };